import { Users } from 'lucide-react'

import { cn } from '@/utilities/ui'

import type { Event, Guest } from '@/payload-types'

export const getAttendeeCount = (event: Event): number =>
  event.relatedGuests?.docs?.filter(
    (guest): guest is Guest =>
      typeof guest === 'object' && guest !== null && guest.approvalStatus === 'approved',
  ).length ?? 0

interface AttendeeCountProps {
  event: Event
  className?: string
}

/** Displays the current amount of attendees registered for an event. */
export const AttendeeCount = ({ event, className }: AttendeeCountProps) => {
  const count = getAttendeeCount(event)

  if (count === 0) return null

  return (
    <span
      className={cn(
        'flex items-center gap-1 font-body text-sm font-medium text-neutral-500',
        className,
      )}
    >
      <Users size={16} />
      <span className="sr-only">Attendees registered</span>
      {count} <span className="hidden sm:inline">{count === 1 ? 'attendee' : 'attendees'}</span>
    </span>
  )
}
